import KYCLimit from 'apps/auth/components/ga/kyc/KYCLimit';
import KYCOnfidoStatus from 'apps/auth/components/ga/kyc/KYCOnfidoStatus/KYCOnfidoStatus';
import SelectCountryBlock from 'apps/auth/components/ga/kyc/SelectCountryBlock';
import KYCSumsubStatus from 'apps/auth/components/kyc/sumsub/KycSumsubStatus';
import KycOfakimDocAddPhotoPage from 'apps/auth/components/profile/ofakim/KycOfakimDocAddPhotoPage';
import KycOfakimDocsList from 'apps/auth/components/profile/ofakim/KycOfakimDocsList';
import KycOfakimStatus from 'apps/auth/components/profile/ofakim/KycOfakimStatus';
import { BUNDLE } from 'apps/auth/constants/EntryPoint';
import { AUTH_VIEW } from 'apps/auth/constants/ServerConstants';
import AntiFraudOnfidoPage from 'apps/auth/pages/kyc/AntiFraudOnfidoPage';
import AntifraudSumsubFramePage from 'apps/auth/pages/kyc/AntifraudSumsubFramePage';
import LuluKycPage from 'apps/auth/pages/kyc/LuluKycPage';
import MyIdKycPage from 'apps/auth/pages/kyc/MyIdKycPage';
import OnfidoDocListPage from 'apps/auth/pages/kyc/OnfidoDocListPage';
import OnfidoFramePage from 'apps/auth/pages/kyc/OnfidoFramePage';
import SumsubFramePage from 'apps/auth/pages/kyc/SumsubFramePage';

const authKyc = [
    {
        path: ['/auth/kyc/ga/limit/intro', '/auth/kyc/gt/limit/intro'],
        component: KYCLimit,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/kyc/:userType/ofakim/doc-types/:country',
        component: KycOfakimDocsList,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
        },
    },
    {
        path: '/auth/kyc/:userType/ofakim/doc/:country/:docId',
        component: KycOfakimDocAddPhotoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
        },
    },
    {
        path: ['/auth/kyc/:userType/ofakim/success', '/auth/kyc/:userType/ofakim/fail', '/auth/kyc/:userType/ofakim/inprogress'],
        component: KycOfakimStatus,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/kyc/select-user-country',
        component: SelectCountryBlock,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/kyc/ca',
        component: OnfidoDocListPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/kyc/documents',
        component: SelectCountryBlock,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: ['/auth/kyc/:userType/onfido/success', '/auth/kyc/:userType/onfido/fail', '/auth/kyc/:userType/onfido/inprogress', '/auth/kyc/inprogress'],
        component: KYCOnfidoStatus,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: ['/auth/kyc/gt/sumsub/success', '/auth/kyc/gt/sumsub/fail', '/auth/kyc/gt/sumsub/inprogress'],
        component: KYCSumsubStatus,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
    {
        path: '/auth/kyc/:userType/onfido/frame/:docType',
        component: OnfidoFramePage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
        },
    },
    {
        path: '/auth/kyc/:userType/onfido/frame',
        component: OnfidoDocListPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
        },
    },
    {
        path: ['auth/kyc/sumsub/frame', 'auth/kyc/gt/sumsub/frame', '/auth/kyc/sumsub/full/identity'],
        component: SumsubFramePage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
        },
    },
    {
        path: '/auth/kyc/uz',
        component: MyIdKycPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
        },
    },
    {
        path: '/auth/kyc/ae',
        component: LuluKycPage,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: false,
        },
    },
    {
        path: ['/auth/antifraud/onfido/:paymentId', '/auth/antifraud/onfido/scenario/:scenarioId/:ticketId'],
        component: AntiFraudOnfidoPage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },

    {
        path: ['/auth/antifraud/sumsub/:paymentId', '/auth/antifraud/sumsub/scenario/:scenarioId/:ticketId'],
        component: AntifraudSumsubFramePage,
        view: AUTH_VIEW,
        isAuthZone: true,
    },
    {
        path: ['/auth/antifraud/sumsub/:paymentId/:status', '/auth/antifraud/sumsub/uploaded/scenario/:scenarioId/:ticketId/:status'],
        component: KYCSumsubStatus,
        view: AUTH_VIEW,
        isAuthZone: true,
        stateOptions: {
            entryPoint: BUNDLE,
            innerPage: true,
            isGA: true,
        },
    },
];
export default authKyc;
